import { render, staticRenderFns } from "./addRoutes.vue?vue&type=template&id=20c86840&"
import script from "./addRoutes.vue?vue&type=script&lang=js&"
export * from "./addRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports